import {RootState} from 'src/store/store';

export const getTriggerAttachments = (state: RootState) =>
    state.triggerAttachments.data;
